import { QuotationTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1491. 見積タスクフェーズ更新（前へ）
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/quotation_tasks/:quotation_task_id/move_to_prev_phase
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  current_quotation_task_phase_id: number;
};

const moveQuotationTaskPhaseToPrev = (props: Props): Promise<QuotationTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/quotation_tasks/${props.task_id}/move_to_prev_phase`,
    props
  );
};

export const useMoveQuotationTaskPhaseToPrev = () => {
  return useMutation({
    mutationFn: moveQuotationTaskPhaseToPrev
  });
};
